"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Chearing_group_left = _interopRequireDefault(require("./images/Chearing_group_left.png"));

var _Chearing_Group_right = _interopRequireDefault(require("./images/Chearing_Group_right.png"));

var _FadeIn = _interopRequireDefault(require("@jobmatchme/ui/es/components/FadeIn"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Profile = require("../../provider/Profile");

var _Form = _interopRequireDefault(require("./Form"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _LanguageSkillsModal = require("../LanguageSkillsModal");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CheckoutPage = function CheckoutPage() {
  var profileCtx = (0, _react.useContext)(_Profile.ProfileContext);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      className: "".concat(_styleModule.default.layoutContainer, " ").concat(_styleModule.default[profileCtx.discriminator ? profileCtx.discriminator : 'care']),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        className: _styleModule.default.header,
        children: " "
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
        color: "primary",
        container: true,
        spacing: 0,
        className: _styleModule.default.green,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
          item: true,
          xs: 12,
          className: _styleModule.default.blue,
          children: profileCtx.discriminator === 'care' && /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: _Chearing_group_left.default,
            alt: "",
            className: _styleModule.default.chearingImageLeft
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
          item: true,
          xs: 12,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FadeIn.default, {
            delay: 600,
            transition: 0.5,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
              className: _styleModule.default.centerContainer,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Form.default, {})
            })
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
          item: true,
          xs: 12,
          className: _styleModule.default.red,
          children: profileCtx.discriminator === 'care' && /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: _Chearing_Group_right.default,
            alt: "",
            className: _styleModule.default.chearingImageRight
          })
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LanguageSkillsModal.DisplayModalIfEmptyLanguages, {})]
  });
};

var _default = CheckoutPage;
exports.default = _default;